<script lang="ts">
	import Tooltip from '../Tooltip.svelte'

	interface Props {
		row: Record<string, string>
		key: string
	}

	let { row, key }: Props = $props()

	const cellText = $derived(row[key] ?? '')
</script>

{#if cellText.trim()}
	<Tooltip
		text={cellText}
		position="top"
		tooltipSize="medium"
		showCopyButton={true}
		class="tooltip-cell-wrapper"
	>
		<div class="cell-content">
			{cellText}
		</div>
	</Tooltip>
{:else}
	<div class="cell-content empty">
		{cellText}
	</div>
{/if}

<style>
	.tooltip-cell-wrapper {
		@apply inline-block w-full;
	}

	.cell-content {
		user-select: text;
		-webkit-user-select: text;
		cursor: text;
		word-break: break-word;
		overflow-wrap: anywhere;
	}

	.cell-content.empty {
		color: #999;
	}
</style>
